import useCategorySortFilter from '@/components/CategoryPage/useCategorySortFilter'
import ImageOptimize from '@/components/ImageOptimize'
import type { Category } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getPath } from '@/utils/next-util'
import { useMemo } from 'react'

interface CategoryProductBrandFiltersProps {
  className?: string
  categoryDetail: Category
}
const CategoryProductBrandFilters = ({
  categoryDetail,
  className,
}: CategoryProductBrandFiltersProps) => {
  const { handleChangeFilter, isFilterActive } = useCategorySortFilter()

  const quickFilters = useMemo(
    () => (categoryDetail.properties || []).filter(x => x.quickFilter),
    [categoryDetail.properties]
  )

  return quickFilters.length ? (
    <div className={`flex flex-col gap-2 ${className}`}>
      {quickFilters.map(quickFilter => (
        <div key={quickFilter._id} className='rounded-xl bg-white px-3 py-5'>
          <h2 className='mb-5 text-xl font-bold text-main'>
            {getTranslate(quickFilter.name)}
          </h2>
          <div className='flex flex-wrap gap-2'>
            {quickFilter.values.map(item => (
              <button
                className={`flex h-12 items-center rounded-xl border px-4 text-sm ${
                  isFilterActive(
                    getPath(quickFilter.slugs),
                    getTranslate(item.value)
                  )
                    ? 'border-primary font-semibold text-primary'
                    : 'border-[#D1D5DB] text-main'
                }`}
                key={item._id}
                onClick={() =>
                  handleChangeFilter(
                    getPath(quickFilter.slugs),
                    getTranslate(item.value)
                  )
                }
              >
                {item.image ? (
                  <ImageOptimize
                    src={item.image}
                    alt={getTranslate(item.value)}
                    height={32}
                    className='h-8 w-auto'
                    loading='lazy'
                  />
                ) : (
                  getTranslate(item.value)
                )}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  ) : null
}

export default CategoryProductBrandFilters
